import { render, staticRenderFns } from "./CacheableComponent.vue?vue&type=template&id=515e5e74&scoped=true&"
import script from "./CacheableComponent.vue?vue&type=script&lang=ts&"
export * from "./CacheableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e5e74",
  null
  
)

export default component.exports